    import $ from "jquery";
import 'select2/dist/css/select2.css';
import select2 from 'select2';

export default class SelectGlobal {
  constructor() {
    this.placeholderText = '';

    this.events();
  }

  events() {
    const currentUrl = window.location.href;
    const isEnglish = currentUrl.includes('/en/');
    this.placeholderText = isEnglish ? "select a topic" : "wybierz";

    $(document).ready(() => {
      $('#contact-subject').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        placeholder: this.placeholderText,
      });
    });
  }
}
